/* ============================
   HALO RING — SHOPIFY LANDING PAGE JS
   Vanilla JS, No Dependencies
   ============================ */

(function () {
  'use strict';

  // -- Announcement Bar Rotation --
  function initAnnouncementBar() {
    var el = document.getElementById('announcementText');
    if (!el) return;

    var messages = [
      'Free Shipping on All Orders \u2014 No Subscription Required',
      '30-Day Risk-Free Returns on All Orders',
      'AI-Powered Ring Sizing \u2014 Find Your Perfect Fit',
      '5-7 Day Battery Life \u2014 Charge in 60 Minutes'
    ];
    var index = 0;

    setInterval(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        index = (index + 1) % messages.length;
        el.textContent = messages[index];
        el.style.opacity = '1';
      }, 400);
    }, 4000);
  }

  // -- Mobile Menu --
  function initMobileMenu() {
    var hamburger = document.getElementById('hamburgerBtn');
    var menu = document.getElementById('mobileMenu');
    var closeBtn = document.getElementById('mobileMenuClose');
    if (!hamburger || !menu) return;

    function open() {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    menu.addEventListener('click', function (e) {
      if (e.target === menu) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) close();
    });

    menu.querySelectorAll('.mobile-menu__link').forEach(function (link) {
      link.addEventListener('click', close);
    });
  }

  // -- Preload all variant images into browser cache --
  function preloadVariantImages() {
    var swatches = document.querySelectorAll('.hero__swatch[data-img]');
    var thumbs = document.querySelectorAll('.hero__thumb img');
    var loaded = {};

    // Preload swatch variant images at main display size
    swatches.forEach(function (s) {
      var url = s.dataset.img;
      if (url && !loaded[url]) {
        loaded[url] = true;
        var img = new Image();
        img.src = url;
      }
    });

    // Preload thumbnail images at main display size
    thumbs.forEach(function (t) {
      var url = t.src.replace(/width=\d+/, 'width=800');
      if (url && !loaded[url]) {
        loaded[url] = true;
        var img = new Image();
        img.src = url;
      }
    });
  }

  // -- Desktop Image Gallery --
  function initDesktopGallery() {
    var thumbnails = document.querySelectorAll('.hero__thumb');
    var mainContainer = document.getElementById('heroMainImage');
    if (!thumbnails.length || !mainContainer) return;

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (this.dataset.mediaType === 'video' && this.dataset.videoUrl) {
          mainContainer.innerHTML = '<video muted loop playsinline class="hero__img" id="heroVideo" style="width:100%;height:auto;border-radius:16px;"><source src="' + this.dataset.videoUrl + '" type="video/mp4"></video>';
          var heroVid = document.getElementById('heroVideo');
          if (heroVid) { heroVid.currentTime = 0; heroVid.play().catch(function(){}); }
        } else {
          var thumbImg = this.querySelector('img');
          if (thumbImg) {
            var mainImg = document.getElementById('heroImg');
            if (!mainImg) {
              mainContainer.innerHTML = '<img class="hero__img" id="heroImg" width="800" height="800" style="width:100%;height:auto;transition:opacity 0.2s ease;">';
              mainImg = document.getElementById('heroImg');
            }
            var newSrc = thumbImg.src.replace(/width=\d+/, 'width=800');
            if (mainImg.src !== newSrc) {
              mainImg.style.opacity = '0';
              mainImg.onload = function () { mainImg.style.opacity = '1'; };
              mainImg.src = newSrc;
            }
          }
        }
        thumbnails.forEach(function (t) {
          t.classList.remove('active');
          t.removeAttribute('aria-current');
        });
        this.classList.add('active');
        this.setAttribute('aria-current', 'true');
      });
    });
  }

  // -- Mobile Carousel --
  function initMobileCarousel() {
    var track = document.querySelector('.hero__carousel-track');
    var dotsContainer = document.getElementById('carouselDots');
    if (!track) return;

    var allSlides = Array.from(track.querySelectorAll('.hero__carousel-slide'));
    var visibleIndices = [];
    var currentPos = 0;

    // Build color -> image indices map
    var colorMap = {};
    if (window.haloImageColors) {
      window.haloImageColors.forEach(function (color, idx) {
        if (!colorMap[color]) colorMap[color] = [];
        colorMap[color].push(idx);
      });
    }

    function filterByColor(colorName) {
      var indices = colorMap[colorName];
      if (!indices || !indices.length) {
        indices = allSlides.map(function (_, i) { return i; });
      }
      visibleIndices = indices;

      allSlides.forEach(function (slide, i) {
        var isVisible = indices.indexOf(i) !== -1;
        slide.style.display = isVisible ? '' : 'none';
        // Lazy-load video element (but don't play yet — wait until slide is in view)
        if (isVisible && slide.dataset.mediaType === 'video' && slide.dataset.videoUrl) {
          var placeholder = slide.querySelector('.hero__video-placeholder');
          if (placeholder) {
            var video = document.createElement('video');
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.preload = 'metadata';
            video.style.cssText = 'width:100%;height:100%;object-fit:cover;';
            video.src = slide.dataset.videoUrl;
            slide.innerHTML = '';
            slide.appendChild(video);
          }
        }
        // Pause all videos when filtering
        var vid = slide.querySelector('video');
        if (vid) vid.pause();
      });

      rebuildDots(indices.length);
      currentPos = 0;
      goToSlide(0, false);
    }

    // Play/pause videos based on which slide is in view
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var vid = entry.target.querySelector('video');
        if (!vid) return;
        if (entry.isIntersecting) {
          vid.currentTime = 0;
          vid.play().catch(function(){});
        } else {
          vid.pause();
        }
      });
    }, { root: track, threshold: 0.6 });

    // Observe all slides for video play/pause
    allSlides.forEach(function (slide) {
      if (slide.dataset.mediaType === 'video') {
        videoObserver.observe(slide);
      }
    });

    function rebuildDots(count) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.className = 'hero__carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.dataset.pos = i;
        dot.addEventListener('click', function () {
          goToSlide(parseInt(this.dataset.pos, 10), true);
        });
        dotsContainer.appendChild(dot);
      }
    }

    function goToSlide(pos, smooth) {
      if (pos < 0) pos = visibleIndices.length - 1;
      if (pos >= visibleIndices.length) pos = 0;
      currentPos = pos;
      var slideIdx = visibleIndices[pos];
      if (allSlides[slideIdx]) {
        allSlides[slideIdx].scrollIntoView({
          behavior: smooth ? 'smooth' : 'auto',
          block: 'nearest',
          inline: 'center'
        });
      }
      updateDots(pos);
    }

    function updateDots(pos) {
      var dots = dotsContainer.querySelectorAll('.hero__carousel-dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === pos);
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var slideIdx = allSlides.indexOf(entry.target);
          var pos = visibleIndices.indexOf(slideIdx);
          if (pos !== -1) {
            currentPos = pos;
            updateDots(pos);
          }
        }
      });
    }, {
      root: track,
      threshold: 0.6
    });

    allSlides.forEach(function (slide) { observer.observe(slide); });

    window.haloFilterCarousel = filterByColor;

    // Init with first active swatch color
    var firstSwatch = document.querySelector('.hero__swatch.active');
    if (firstSwatch && firstSwatch.dataset.color) {
      filterByColor(firstSwatch.dataset.color);
    } else if (window.haloImageColors && window.haloImageColors[0]) {
      filterByColor(window.haloImageColors[0]);
    } else {
      visibleIndices = allSlides.map(function (_, i) { return i; });
      rebuildDots(visibleIndices.length);
    }
  }

  // -- Color Swatch Selection --
  function initColorSwatches() {
    var allSwatches = document.querySelectorAll('.hero__swatch');
    var colorName = document.getElementById('colorName');
    var colorPrice = document.getElementById('colorPrice');
    var colorComparePrice = document.getElementById('colorComparePrice');
    var colorSaleBadge = document.getElementById('colorSaleBadge');
    var colorInfo = document.getElementById('colorInfo');
    var mainImg = document.getElementById('heroImg');
    var stickySwatchColor = document.getElementById('stickySwatchColor');
    var stickyRingImg = document.getElementById('stickyRingImg');
    var stickyPrice = document.querySelector('.sticky-cta__price');
    if (!allSwatches.length) return;

    allSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        allSwatches.forEach(function (s) {
          s.classList.remove('active');
          s.setAttribute('aria-checked', 'false');
        });

        this.classList.add('active');
        this.setAttribute('aria-checked', 'true');

        var color = this.dataset.color;
        var price = this.dataset.price;
        var comparePrice = this.dataset.comparePrice;

        if (colorInfo) colorInfo.style.display = 'block';
        if (colorName) colorName.textContent = color;
        if (colorPrice) colorPrice.textContent = price;

        if (comparePrice) {
          if (colorComparePrice) { colorComparePrice.textContent = comparePrice; colorComparePrice.style.display = ''; }
          if (colorSaleBadge) colorSaleBadge.style.display = '';
        } else {
          if (colorComparePrice) { colorComparePrice.textContent = ''; colorComparePrice.style.display = 'none'; }
          if (colorSaleBadge) colorSaleBadge.style.display = 'none';
        }

        if (stickySwatchColor) stickySwatchColor.style.background = this.style.background;
        if (stickyRingImg && this.dataset.img) stickyRingImg.src = this.dataset.img;
        if (stickyPrice) stickyPrice.textContent = price;

        // Filter mobile carousel to show only this color's images
        if (window.haloFilterCarousel && color) {
          window.haloFilterCarousel(color);
        }

        // Filter desktop thumbnails by color and show first lifestyle image
        var thumbs = document.querySelectorAll('.hero__thumb');
        var colors = window.haloImageColors || [];
        var firstShown = false;
        // Restore img element if video was showing
        var mainImg = document.getElementById('heroImg');
        if (!mainImg) {
          var mainContainer = document.getElementById('heroMainImage');
          if (mainContainer) {
            mainContainer.innerHTML = '<img class="hero__img" id="heroImg" width="800" height="800" style="width:100%;height:auto;transition:opacity 0.2s ease;">';
            mainImg = document.getElementById('heroImg');
          }
        }
        if (mainImg && !mainImg.style.transition) mainImg.style.transition = 'opacity 0.2s ease';
        thumbs.forEach(function (t, i) {
          var imgColor = colors[i] || '';
          if (imgColor === color) {
            t.style.display = '';
            if (!firstShown) {
              t.classList.add('active');
              t.style.borderColor = '#B76E79';
              t.setAttribute('aria-current', 'true');
              // Show first matching image (lifestyle) as main image
              var thumbImg = t.querySelector('img');
              if (thumbImg && mainImg) {
                var newSrc = thumbImg.src.replace(/width=\d+/, 'width=800');
                mainImg.style.opacity = '0';
                mainImg.onload = function () { mainImg.style.opacity = '1'; };
                mainImg.src = newSrc;
              }
              firstShown = true;
            } else {
              t.classList.remove('active');
              t.style.borderColor = 'transparent';
              t.removeAttribute('aria-current');
            }
          } else {
            t.style.display = 'none';
            t.classList.remove('active');
            t.style.borderColor = 'transparent';
            t.removeAttribute('aria-current');
          }
        });
        // Fallback: if no thumbnails matched, use variant image
        if (!firstShown && mainImg && this.dataset.img) {
          mainImg.style.opacity = '0';
          mainImg.onload = function () { mainImg.style.opacity = '1'; };
          mainImg.src = this.dataset.img;
        }

        // Update size availability for this color
        updateSizeAvailability(color);

        // Update Shopify variant selection
        updateVariantId();
      });
    });

    // Initial filter: trigger click on first swatch to select it on load
    var firstActive = document.querySelector('.hero__swatch.active') || document.querySelector('.hero__swatch');
    if (firstActive) {
      firstActive.click();
    }
  }

  // -- Update size availability based on selected color --
  // Ceramic and Frosted colors start at size 7 (no size 6)
  var restrictedColorPrefixes = ['Ceramic', 'Frosted'];
  var restrictedMinSize = 7;

  function updateSizeAvailability(selectedColor) {
    var sizeBtns = document.querySelectorAll('.hero__size-btn');
    if (!sizeBtns.length) return;

    var isRestricted = false;
    if (selectedColor) {
      for (var i = 0; i < restrictedColorPrefixes.length; i++) {
        if (selectedColor.indexOf(restrictedColorPrefixes[i]) === 0) {
          isRestricted = true;
          break;
        }
      }
    }

    sizeBtns.forEach(function (btn) {
      var size = parseInt(btn.dataset.size, 10);
      if (isRestricted && size < restrictedMinSize) {
        btn.classList.add('unavailable');
        btn.disabled = true;
        if (btn.classList.contains('active')) {
          btn.classList.remove('active');
          btn.setAttribute('aria-checked', 'false');
        }
      } else {
        btn.classList.remove('unavailable');
        btn.disabled = false;
      }
    });
  }

  // -- Sizing Toggle --
  function initSizingToggle() {
    var toggleBtn = document.getElementById('sizingToggleBtn');
    var toggleWrap = document.getElementById('sizingToggle');
    var sizeCircles = document.getElementById('sizeCircles');
    var sizeBtns = document.querySelectorAll('.hero__size-btn');

    if (toggleBtn && sizeCircles) {
      toggleBtn.addEventListener('click', function () {
        var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          sizeCircles.classList.remove('open');
          toggleBtn.setAttribute('aria-expanded', 'false');
          sizeCircles.setAttribute('aria-hidden', 'true');
        } else {
          sizeCircles.classList.add('open');
          toggleBtn.setAttribute('aria-expanded', 'true');
          sizeCircles.setAttribute('aria-hidden', 'false');
          if (toggleWrap) toggleWrap.classList.add('active');
        }
      });
    }

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-checked', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-checked', 'true');
        if (toggleWrap) toggleWrap.classList.add('active');
        updateVariantId();
      });
    });
  }

  // -- Warranty Selection --
  function initWarranty() {
    var cards = document.querySelectorAll('.hero__warranty-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) {
          c.classList.remove('active');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-checked', 'true');
      });
    });
  }

  // -- Charging Case Selection --
  function initChargingCase() {
    var cards = document.querySelectorAll('.hero__charging-case-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) {
          c.classList.remove('active');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-checked', 'true');
      });
    });
  }

  // -- Sticky Bottom CTA --
  function initStickyCta() {
    var stickyCta = document.getElementById('stickyCta');
    var atcButton = document.getElementById('addToCart');
    if (!stickyCta) return;
    if (!atcButton) return;

    function showSticky() {
      stickyCta.classList.add('visible');
      stickyCta.setAttribute('aria-hidden', 'false');
    }
    function hideSticky() {
      stickyCta.classList.remove('visible');
      stickyCta.setAttribute('aria-hidden', 'true');
    }

    // Scroll-based fallback: show when ATC button is above viewport
    window.addEventListener('scroll', function () {
      var rect = atcButton.getBoundingClientRect();
      if (rect.bottom < 0) {
        showSticky();
      } else {
        hideSticky();
      }
    }, { passive: true });
  }

  // -- FAQ Accordion --
  function initBuyboxFaq() {
    var triggers = document.querySelectorAll('.hero__faq-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = this.parentElement;
        var content = this.nextElementSibling;
        var isOpen = item.classList.contains('open');

        // Close all
        triggers.forEach(function (t) {
          t.parentElement.classList.remove('open');
          t.setAttribute('aria-expanded', 'false');
          t.nextElementSibling.style.maxHeight = null;
        });

        // Open clicked if was closed
        if (!isOpen) {
          item.classList.add('open');
          this.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  function initFaqAccordion() {
    var questions = document.querySelectorAll('.faq__question');
    if (!questions.length) return;

    questions.forEach(function (question) {
      question.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var answer = this.nextElementSibling;

        questions.forEach(function (q) {
          q.setAttribute('aria-expanded', 'false');
          var a = q.nextElementSibling;
          if (a) {
            a.style.maxHeight = null;
            a.setAttribute('aria-hidden', 'true');
          }
        });

        if (!expanded) {
          this.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  // -- Scroll Reveal --
  function initScrollReveal() {
    var sections = document.querySelectorAll(
      '.trust-bar, .features, .biomarkers, .reviews, .inbox, .compare, .specs, .faq, .newsletter'
    );
    if (!sections.length) return;

    sections.forEach(function (s) { s.classList.add('reveal'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    sections.forEach(function (s) { observer.observe(s); });
  }

  // -- Smooth Scroll --
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  // -- Newsletter Form --
  function initNewsletterForm() {
    var form = document.getElementById('newsletterForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('.newsletter__input');
      var btn = form.querySelector('.newsletter__submit');
      if (input && input.value) {
        btn.textContent = 'Subscribed!';
        btn.style.background = '#B76E79';
        input.value = '';
        setTimeout(function () {
          btn.textContent = 'Subscribe';
          btn.style.background = '';
        }, 3000);
      }
    });
  }

  // -- Shopify Variant ID Update --
  // Maps selected color + size to the correct Shopify variant ID
  function updateVariantId() {
    var variantInput = document.getElementById('haloVariantId');
    var productData = window.haloProductVariants;
    if (!variantInput || !productData) return;

    var activeSwatch = document.querySelector('.hero__swatch.active');
    var activeSize = document.querySelector('.hero__size-btn.active');

    var selectedColor = activeSwatch ? activeSwatch.dataset.color : null;
    var selectedSize = activeSize ? activeSize.dataset.size : null;

    // Find matching variant
    for (var i = 0; i < productData.length; i++) {
      var v = productData[i];
      var colorMatch = !selectedColor || v.option1 === selectedColor;
      var sizeMatch = !selectedSize || v.option2 === selectedSize;
      if (colorMatch && sizeMatch && v.available) {
        variantInput.value = v.id;
        return;
      }
    }
  }

  // -- Add to Cart (Shopify AJAX) --
  // Adds main product + warranty (if has variant) to cart
  function initAddToCart() {
    var atcBtn = document.getElementById('addToCart');
    var stickyBtn = document.querySelector('.sticky-cta__btn');

    function collectCartItems() {
      var items = [];
      var variantId = document.getElementById('haloVariantId');
      if (!variantId || !variantId.value) return null;

      // Main product
      items.push({ id: parseInt(variantId.value, 10), quantity: 1 });

      // Warranty — add the active warranty if it has a linked product
      var activeWarranty = document.querySelector('.hero__warranty-card.active');
      if (activeWarranty && activeWarranty.dataset.variantId) {
        items.push({ id: parseInt(activeWarranty.dataset.variantId, 10), quantity: 1 });
      }

      // Charging case — add if "add" option is selected and has a variant
      var activeCase = document.querySelector('.hero__charging-case-card.active');
      if (activeCase && activeCase.dataset.case === 'add' && activeCase.dataset.variantId) {
        items.push({ id: parseInt(activeCase.dataset.variantId, 10), quantity: 1 });
      }

      return items;
    }

    function updateCartCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var countEls = document.querySelectorAll('.nav__cart-count');
          countEls.forEach(function (el) { el.textContent = cart.item_count; });
        });
    }

    function handleAddToCart(e) {
      e.preventDefault();
      var items = collectCartItems();
      if (!items) {
        alert('Please select a color and size.');
        return;
      }

      var btn = e.currentTarget;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'Could not add to cart');
            });
          }
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added to Cart!';
          btn.style.background = '#A89080';
          updateCartCount();
          // Redirect to cart page
          setTimeout(function() {
            window.location.href = '/cart';
          }, 800);
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        })
        .catch(function (err) {
          btn.textContent = err.message || 'Error - Try Again';
          btn.style.background = '#ef4444';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        });
    }

    if (atcBtn) atcBtn.addEventListener('click', handleAddToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', handleAddToCart);
  }

  // -- Nav Scroll Shadow --
  function initNavScroll() {
    var nav = document.getElementById('mainNav');
    if (!nav) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // -- Init --
  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncementBar();
    initMobileMenu();
    initDesktopGallery();
    initMobileCarousel();
    initColorSwatches();
    preloadVariantImages();
    initSizingToggle();
    initWarranty();
    initChargingCase();
    initStickyCta();
    initBuyboxFaq();
    initFaqAccordion();
    initScrollReveal();
    initSmoothScroll();
    initNewsletterForm();
    initAddToCart();
    initNavScroll();
    initExperienceTabs();
    initCountdownTimers();
  });

  // -- Countdown Timers (Spring Sale) --
  function initCountdownTimers() {
    // Two cycles per day:
    //   Cycle 1: 6:59 AM → 11:59 PM (17h 0m)
    //   Cycle 2: 12:00 AM → 6:59 AM (6h 59m)
    // Timer always counts down, never sits still.

    var timers = document.querySelectorAll('[data-countdown-timer]');
    var heroCountdown = document.getElementById('heroCountdown');

    function pad(n) { return n < 10 ? '0' + n : n; }

    function tick() {
      var now = new Date();
      var h = now.getHours();
      var end = new Date(now);

      if (h < 7) {
        // Midnight to 6:59 AM — count down to 6:59 AM
        end.setHours(6, 59, 0, 0);
      } else {
        // 7:00 AM to 11:59 PM — count down to 11:59 PM
        end.setHours(23, 59, 0, 0);
      }

      var remaining = end.getTime() - now.getTime();
      if (remaining < 0) remaining = 0;
      var rh = Math.floor(remaining / 3600000);
      var rm = Math.floor((remaining % 3600000) / 60000);
      var rs = Math.floor((remaining % 60000) / 1000);
      var str = pad(rh) + 'h ' + pad(rm) + 'm ' + pad(rs) + 's';
      timers.forEach(function (el) { el.textContent = str; });
    }

    if (timers.length) {
      tick();
      setInterval(tick, 1000);
    }

    // Show hero countdown when a swatch with compare-at price is clicked
    if (heroCountdown) {
      document.addEventListener('click', function (e) {
        var swatch = e.target.closest('.hero__swatch');
        if (!swatch) return;
        heroCountdown.style.display = swatch.dataset.comparePrice ? 'flex' : 'none';
      });
      // Show immediately if an active swatch already has a compare price on load
      var activeSwatch = document.querySelector('.hero__swatch.active');
      if (activeSwatch && activeSwatch.dataset.comparePrice) {
        heroCountdown.style.display = 'flex';
      }
    }
  }

  // -- Experience Tabs --
  function initExperienceTabs() {
    var tabs = document.querySelectorAll('.experience__tab');
    var slides = document.querySelectorAll('.experience__slide');
    if (!tabs.length || !slides.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = this.getAttribute('data-tab');

        tabs.forEach(function (t) { t.classList.remove('active'); });
        slides.forEach(function (s) { s.classList.remove('active'); });

        this.classList.add('active');
        var target = document.querySelector('.experience__slide[data-slide="' + idx + '"]');
        if (target) target.classList.add('active');
      });
    });
  }

})();
